import React, { useEffect, useState } from 'react';

const isBlockedBrowser = () => {
    const ua = navigator.userAgent;

    const isOpera = /OPR\/|Opera/.test(ua);
    const isEdge = /EdgA?i?OS?|Edge\//.test(ua) || /Edg\//.test(ua);

    return isOpera || isEdge;
};

export default function BrowserGuard({ children }) {
    const [isBlocked, setIsBlocked] = useState(false);

    useEffect(() => {
        if (isBlockedBrowser()) {
            setIsBlocked(true);
        }
    }, []);

    if (isBlocked) {
        return (
            <div style={styles.container}>
                <i style={styles.title}><b>Navegador NO soportado</b></i>
                <p style={styles.text}>Estimado Usuario, el navegador que está utilizando NO soporta la ejecución de ContaBot, favor de utilizar alguno de los siguientes navegadores: Google Chrome, Mozilla Firefox, o Safari (En windows) versión mayor a 5.1.7.</p>
            </div>
        );
    }

    return <>{children}</>;
}

const styles = {
    container: {
        backgroundImage: 'url("/BGCP.JPG")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '100vh',
        color: 'white',
        padding: "2rem",
        fontFamily: "sans-serif",
        display: 'flex',             
        flexDirection: 'column',     
        justifyContent: 'center',    
        alignItems: 'center',        
        textAlign: 'center'          
    },
    title: {
        fontSize: '3rem',
        fontStyle: 'italic',
        marginBottom: '1rem'
    },
    text: {
        fontSize: '1.5rem',
        maxWidth: '800px' 
    }
}

